import type { Gender } from '~constants/gender';

export type DesireId = number;

export const CREATED_BY = ['community', 'eva'] as const;

export type CreatedBy = (typeof CREATED_BY)[number];

export const isCreatedBy = (value: string): value is CreatedBy =>
	CREATED_BY.includes(value as CreatedBy);

export type Desire = string;
export type TGridFilters = {
	gender?: Gender | null;
	minAge?: number;
	maxAge?: number;
	desire?: string;
	keyword?: string;
	createdBy?: CreatedBy | null;
};
